export default __webpack_public_path__ + "static/media/2.f9e3b6f4.png";